import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Toaster } from 'sonner';
import { Leaderboard } from './Stats';
import CDLInfo from './CDLInfo';
import LoadingSpinner from './LoadingSpinner';
import { API } from '../lib/api';

export function PublicDashboard() {
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const [showCDLInfo, setShowCDLInfo] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadTournaments();
  }, []);

  const loadTournaments = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/public/tournaments`);
      setTournaments(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="min-h-screen bg-[#050505]">
    <Toaster position="top-right" theme="dark" />
    <div className="tactical-grid fixed inset-0 opacity-20" />
    <div className="scan-line" />
    
    <div className="relative z-10">
      <header className="border-b border-white/10 bg-black/50 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div className="slide-in">
              <h1 className="font-primary font-black text-2xl sm:text-3xl lg:text-4xl tracking-tighter uppercase text-[#ff4500]">
                BLACK OPS 7 <span className="text-white">TOURNAMENT</span>
              </h1>
              <div className="flex flex-col gap-1 mt-1 sm:mt-2">
                <p className="font-secondary text-xs text-muted-foreground tracking-wider">
                  MODE VISITEUR - LECTURE SEULE
                </p>
                <a
                  href="https://www.twitch.tv/azwikur"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-[#9146ff] font-secondary text-xs transition-all duration-200 hover:underline"
                >
                  <img 
                    src="https://static-cdn.jtvnw.net/jtv_user_pictures/1545dfd4-4f0f-4277-a7a0-bf2843bacc2a-profile_image-70x70.png" 
                    alt="Twitch" 
                    className="w-4 h-4 transition-transform duration-200 hover:scale-125"
                  />
                  <span className="hover:text-[#bc9cff]">Azwikur TV</span>
                </a>
              </div>
            </div>
            {/* Menu Desktop */}
            <div className="hidden sm:flex gap-2 sm:gap-4 items-center flex-wrap">
  {[
    { label: "GUIDE CDL", action: () => setShowCDLInfo(true), testid: "cdl-info-btn" },
    { label: "CLASSEMENT", action: () => setShowLeaderboard(true), testid: "leaderboard-btn" },
    { label: "CONNEXION ADMIN", action: () => navigate('/login'), testid: "login-btn" }
  ].map(btn => (
    <button
      key={btn.label}
      onClick={btn.action}
      data-testid={btn.testid}
      className="
        bg-zinc-800
        border border-orange-800
        text-orange-700
        font-bold
        uppercase
        tracking-widest
        px-3 sm:px-4 lg:px-6
        py-1.5 sm:py-2
        skew-x-[-12deg]
        hover:bg-orange-500
        hover:text-black
        transition-all
        font-secondary
        text-[10px] sm:text-xs
      "
    >
      <span className="block skew-x-[12deg]">
        {btn.label}
      </span>
    </button>
  ))}
</div>

              {/* Bouton Menu Mobile */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="sm:hidden bg-zinc-800 border border-orange-800 text-orange-700 p-2 hover:bg-orange-500 hover:text-black transition-all"
                aria-label="Menu"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {mobileMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
          </div>

          {/* Menu Mobile Dropdown */}
          {mobileMenuOpen && (
            <div className="sm:hidden mt-4 pt-4 border-t border-white/10 animate-in slide-in-from-top">
              <div className="flex flex-col gap-2">
                {[
                  { label: "GUIDE CDL", action: () => { setShowCDLInfo(true); setMobileMenuOpen(false); }, testid: "mobile-cdl-info-btn" },
                  { label: "CLASSEMENT", action: () => { setShowLeaderboard(true); setMobileMenuOpen(false); }, testid: "mobile-leaderboard-btn" },
                  { label: "CONNEXION ADMIN", action: () => { navigate('/login'); setMobileMenuOpen(false); }, testid: "mobile-login-btn" }
                ].map(btn => (
                  <button
                    key={btn.label}
                    onClick={btn.action}
                    data-testid={btn.testid}
                    className="
                      w-full
                      bg-zinc-800
                      border border-orange-800
                      text-orange-700
                      font-bold
                      uppercase
                      tracking-widest
                      px-4
                      py-3
                      skew-x-[-12deg]
                      hover:bg-orange-500
                      hover:text-black
                      transition-all
                      font-secondary
                      text-xs
                      text-left
                    "
                  >
                    <span className="block skew-x-[12deg]">
                      {btn.label}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </header>

      <main className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
        <div className="mb-6 sm:mb-8">
          <h2 className="font-primary font-black text-xl sm:text-2xl uppercase tracking-tighter">TOURNOIS PUBLICS</h2>
          <p className="font-secondary text-xs text-muted-foreground mt-1">ACCÈS LECTURE SEULE</p>
        </div>

        {showLeaderboard && (
          <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 fade-in">
            <div className="bg-[#0a0a0a] border border-[#262626] p-8 max-w-2xl w-full corner-decoration relative slide-in max-h-[80vh] overflow-y-auto">
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-primary font-black text-xl uppercase">CLASSEMENT GÉNÉRAL</h3>
                <button
                  onClick={() => setShowLeaderboard(false)}
                  className="text-muted-foreground hover:text-white font-secondary text-xs uppercase"
                >
                  FERMER
                </button>
              </div>
              <Leaderboard isPublic={true} />
            </div>
          </div>
        )}

        {showCDLInfo && <CDLInfo onClose={() => setShowCDLInfo(false)} isPublic={true} />}

        {loading ? (
          <LoadingSpinner text="Chargement des tournois..." />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {tournaments.map((t) => (
              <div
                key={t.id}
                className="bg-[#0a0a0a] border border-[#262626] p-6 hover:border-[#ff4500]/50 transition-all cursor-pointer corner-decoration relative group hover-lift team-card-hover slide-in"
                onClick={() => navigate(`/public/tournament/${t.id}`)}
              >
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="font-primary font-bold text-lg uppercase">{t.name}</h3>
                    <p className={`font-secondary text-xs uppercase mt-1 ${
                      t.status === 'setup' ? 'text-[#4169e1]' : t.status === 'in_progress' ? 'text-[#00ff9d]' : 'text-[#ffd700]'
                    }`}>
                      {t.status === 'setup' ? '● Configuration' : t.status === 'in_progress' ? '● En cours' : '● Terminé'}
                    </p>
                  </div>
                </div>
                <div className="font-secondary text-xs text-muted-foreground">
                  <div className="flex justify-between py-2 border-t border-white/5">
                    <span>CRÉÉ LE</span>
                    <span>{new Date(t.created_at).toLocaleDateString('fr-FR')}</span>
                  </div>
                  {t.winner_id && (
                    <div className="mt-2 px-3 py-2 bg-[#ffd700]/10 border border-[#ffd700]/30">
                      <span className="text-[#ffd700] uppercase">🏆 Champion</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {!loading && tournaments.length === 0 && (
          <div className="text-center py-20">
            <p className="font-secondary text-muted-foreground">Aucun tournoi public disponible pour le moment.</p>
          </div>
        )}
      </main>
    </div>
  </div>
);

}

export function PublicTournamentView() {
  const { id } = useParams();
  const [tournament, setTournament] = useState(null);
  const [teams, setTeams] = useState([]);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedTeams, setExpandedTeams] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [tRes, teamsRes, matchesRes] = await Promise.all([
        axios.get(`${API}/public/tournaments/${id}`),
        axios.get(`${API}/public/tournaments/${id}/teams`),
        axios.get(`${API}/public/tournaments/${id}/matches`)
      ]);
      setTournament(tRes.data);
      setTeams(teamsRes.data);
      setMatches(matchesRes.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner text="Chargement du tournoi..." />;
  if (!tournament) return <div className="min-h-screen bg-[#050505] flex items-center justify-center font-secondary text-muted-foreground">Tournoi non trouvé</div>;

  const isDoubleElimination = tournament.tournament_type === "double";
  
  // Organize matches by bracket type
  const winnerBracket = {};
  const loserBracket = {};
  const grandFinals = [];
  
  matches.forEach(m => {
    if (m.bracket_type === "grand_finals") {
      grandFinals.push(m);
    } else if (m.bracket_type === "loser") {
      if (!loserBracket[m.bracket_round]) loserBracket[m.bracket_round] = [];
      loserBracket[m.bracket_round].push(m);
    } else {
      // winner bracket (default)
      if (!winnerBracket[m.bracket_round]) winnerBracket[m.bracket_round] = [];
      winnerBracket[m.bracket_round].push(m);
    }
  });

  // Helper function to get round label
  const getRoundLabel = (roundNum, totalRounds, bracketType = "winner") => {
    if (bracketType === "grand_finals") return "GRAND FINALS";
    if (bracketType === "loser") {
      if (roundNum === 1) return "LOSER ROUND 1";
      return `LOSER ROUND ${roundNum}`;
    }
    // Winner bracket
    if (roundNum === totalRounds) return "FINALE";
    if (roundNum === totalRounds - 1) return "DEMI-FINALE";
    if (roundNum === totalRounds - 2) return "QUART DE FINALE";
    return `ROUND ${roundNum}`;
  };
  
  const totalWinnerRounds = Math.max(...Object.keys(winnerBracket).map(Number), 0);

  const toggleTeamPlayers = (teamId) => {
    setExpandedTeams((prev) => ({ ...prev, [teamId]: !prev[teamId] }));
  };

  return (
    <div className="min-h-screen bg-[#050505]">
      <div className="tactical-grid fixed inset-0 opacity-20" />
      
      <div className="relative z-10">
        <header className="border-b border-white/10 bg-black/50 backdrop-blur-sm">
          <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
            <button
              onClick={() => navigate('/public')}
              className="font-secondary text-xs text-[#ff4500] uppercase mb-3 sm:mb-4 hover:text-[#ff4500]/80"
            >
              ← RETOUR
            </button>
            <h1 className="font-primary font-black text-xl sm:text-2xl lg:text-3xl tracking-tighter uppercase break-words">{tournament.name}</h1>
            <p className="font-secondary text-xs text-muted-foreground mt-1 sm:mt-2 tracking-wider uppercase">{tournament.status} - MODE VISITEUR</p>
          </div>
        </header>

        <main className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            <div className="lg:col-span-1">
              <div className="bg-[#0a0a0a] border border-[#262626] p-4 sm:p-6 corner-decoration relative">
                <h2 className="font-primary font-black text-lg sm:text-xl uppercase mb-4 sm:mb-6">ÉQUIPES</h2>
                {teams.map((team) => (
                  <div key={team.id} className="py-3 border-b border-white/5">
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex items-center gap-2 min-w-0">
                        {team.logo_url && (
                          <img 
                            src={team.logo_url} 
                            alt={team.name} 
                            className="w-6 h-6 object-contain flex-shrink-0"
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        )}
                        <span className="font-secondary text-sm truncate">{team.name}</span>
                      </div>
                      <button
                        onClick={() => toggleTeamPlayers(team.id)}
                        className="font-secondary text-[10px] uppercase px-2 py-1 border border-[#ff4500]/50 text-[#ff4500] hover:bg-[#ff4500]/10 whitespace-nowrap"
                      >
                        {expandedTeams[team.id] ? 'Masquer joueurs' : 'Voir joueurs'}
                      </button>
                    </div>
                    {expandedTeams[team.id] && (
                      <div className="mt-2 pl-8">
                        {team.players?.length > 0 ? (
                          <ul className="space-y-1">
                            {team.players.map((player, index) => (
                              <li key={`${team.id}_${index}`} className="font-secondary text-xs text-white/80">
                                - {player}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="font-secondary text-xs text-muted-foreground">Aucun joueur renseigné</p>
                        )}
                      </div>
                    )}
                  </div>
                ))}
                {teams.length === 0 && (
                  <p className="font-secondary text-xs text-muted-foreground text-center py-8">Aucune équipe</p>
                )}
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="bg-[#0a0a0a] border border-[#262626] p-4 sm:p-6 corner-decoration relative">
                <h2 className="font-primary font-black text-lg sm:text-xl uppercase mb-4 sm:mb-6">BRACKET</h2>
                {matches.length === 0 ? (
                  <p className="font-secondary text-xs text-muted-foreground text-center py-10 sm:py-20">Bracket non généré</p>
                ) : (
                  <div className="space-y-8">
                    {/* Winner Bracket */}
                    <div>
                      <h3 className="font-secondary text-sm text-[#ff4500] uppercase tracking-wider mb-4">WINNER BRACKET</h3>
                      <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
                        <div className="flex gap-4 sm:gap-6 lg:gap-8 min-w-max pb-4">
                          {Object.keys(winnerBracket).sort((a, b) => a - b).map((roundNum) => (
                            <div key={roundNum} className="flex flex-col gap-3 sm:gap-4 min-w-[200px] sm:min-w-[220px] lg:min-w-[250px]">
                              <h4 className="font-secondary text-[10px] sm:text-xs text-[#ff4500] uppercase tracking-wider mb-2">
                                {getRoundLabel(Number(roundNum), totalWinnerRounds, "winner")}
                              </h4>
                              {winnerBracket[roundNum].map((match) => {
                            const team1 = teams.find(t => t.id === match.team1_id);
                            const team2 = teams.find(t => t.id === match.team2_id);
                            
                            return (
                              <div 
                                key={match.id} 
                                    className="bg-[#1a1a1a] border border-[#262626] p-3 sm:p-4 hover:border-[#ff4500]/50 transition-all cursor-pointer"
                                onClick={() => navigate(`/public/match/${match.id}`)}
                              >
                                <div className="flex items-center justify-between mb-2">
                                      <span className="font-secondary text-[10px] sm:text-xs text-muted-foreground">MATCH {match.match_number}</span>
                                      <span className="font-secondary text-[10px] sm:text-xs text-[#00ff9d] uppercase">{match.status}</span>
                                </div>
                                    <div className="space-y-1.5 sm:space-y-2">
                                      <div className={`flex items-center justify-between py-1.5 sm:py-2 px-2 sm:px-3 ${
                                    match.winner_id === match.team1_id ? 'bg-[#ff4500]/20' : 'bg-[#0a0a0a]'
                                  }`}>
                                        <div className="flex items-center gap-1.5 sm:gap-2 flex-1 min-w-0">
                                          {team1?.logo_url && (
                                            <img 
                                              src={team1.logo_url} 
                                              alt={team1.name} 
                                              className="w-5 h-5 sm:w-6 sm:h-6 object-contain flex-shrink-0"
                                              onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                          )}
                                          <span className="font-secondary text-xs sm:text-sm truncate">{team1?.name || 'TBD'}</span>
                                        </div>
                                        <span className="font-secondary text-xs sm:text-sm font-bold ml-2 flex-shrink-0">{match.team1_wins || 0}</span>
                                  </div>
                                      <div className={`flex items-center justify-between py-1.5 sm:py-2 px-2 sm:px-3 ${
                                    match.winner_id === match.team2_id ? 'bg-[#ff4500]/20' : 'bg-[#0a0a0a]'
                                  }`}>
                                        <div className="flex items-center gap-1.5 sm:gap-2 flex-1 min-w-0">
                                          {team2?.logo_url && (
                                            <img 
                                              src={team2.logo_url} 
                                              alt={team2.name} 
                                              className="w-5 h-5 sm:w-6 sm:h-6 object-contain flex-shrink-0"
                                              onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                          )}
                                          <span className="font-secondary text-xs sm:text-sm truncate">{team2?.name || 'TBD'}</span>
                                        </div>
                                        <span className="font-secondary text-xs sm:text-sm font-bold ml-2 flex-shrink-0">{match.team2_wins || 0}</span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                      </div>
                    </div>

                    {/* Loser Bracket (only for double elimination) */}
                    {isDoubleElimination && Object.keys(loserBracket).length > 0 && (
                      <div className="mt-8">
                        <h3 className="font-secondary text-sm text-[#00ff9d] uppercase tracking-wider mb-4">LOSER BRACKET</h3>
                        <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
                          <div className="flex gap-4 sm:gap-6 lg:gap-8 min-w-max pb-4">
                            {Object.keys(loserBracket).sort((a, b) => a - b).map((roundNum) => (
                              <div key={roundNum} className="flex flex-col gap-3 sm:gap-4 min-w-[200px] sm:min-w-[220px] lg:min-w-[250px]">
                                <h4 className="font-secondary text-[10px] sm:text-xs text-[#00ff9d] uppercase tracking-wider mb-2">
                                  {getRoundLabel(Number(roundNum), 0, "loser")}
                                </h4>
                                {loserBracket[roundNum].map((match) => {
                                  const team1 = teams.find(t => t.id === match.team1_id);
                                  const team2 = teams.find(t => t.id === match.team2_id);
                                  
                                  return (
                                    <div 
                                      key={match.id} 
                                      className="bg-[#1a1a1a] border border-[#262626] p-3 sm:p-4 hover:border-[#00ff9d]/50 transition-all cursor-pointer"
                                      onClick={() => navigate(`/public/match/${match.id}`)}
                                    >
                                      <div className="flex items-center justify-between mb-2">
                                        <span className="font-secondary text-[10px] sm:text-xs text-muted-foreground">MATCH {match.match_number}</span>
                                        <span className="font-secondary text-[10px] sm:text-xs text-[#00ff9d] uppercase">{match.status}</span>
                                      </div>
                                      <div className="space-y-1.5 sm:space-y-2">
                                        <div className={`flex items-center justify-between py-1.5 sm:py-2 px-2 sm:px-3 ${
                                          match.winner_id === match.team1_id ? 'bg-[#00ff9d]/20' : 'bg-[#0a0a0a]'
                                        }`}>
                                          <div className="flex items-center gap-1.5 sm:gap-2 flex-1 min-w-0">
                                            {team1?.logo_url && (
                                              <img 
                                                src={team1.logo_url} 
                                                alt={team1.name} 
                                                className="w-5 h-5 sm:w-6 sm:h-6 object-contain flex-shrink-0"
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                              />
                                            )}
                                            <span className="font-secondary text-xs sm:text-sm truncate">{team1?.name || 'TBD'}</span>
                                          </div>
                                          <span className="font-secondary text-xs sm:text-sm font-bold ml-2 flex-shrink-0">{match.team1_wins || 0}</span>
                                        </div>
                                        <div className={`flex items-center justify-between py-1.5 sm:py-2 px-2 sm:px-3 ${
                                          match.winner_id === match.team2_id ? 'bg-[#00ff9d]/20' : 'bg-[#0a0a0a]'
                                        }`}>
                                          <div className="flex items-center gap-1.5 sm:gap-2 flex-1 min-w-0">
                                            {team2?.logo_url && (
                                              <img 
                                                src={team2.logo_url} 
                                                alt={team2.name} 
                                                className="w-5 h-5 sm:w-6 sm:h-6 object-contain flex-shrink-0"
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                              />
                                            )}
                                            <span className="font-secondary text-xs sm:text-sm truncate">{team2?.name || 'TBD'}</span>
                                          </div>
                                          <span className="font-secondary text-xs sm:text-sm font-bold ml-2 flex-shrink-0">{match.team2_wins || 0}</span>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Grand Finals (only for double elimination) */}
                    {isDoubleElimination && grandFinals.length > 0 && (
                      <div className="mt-8">
                        <h3 className="font-secondary text-sm text-[#ffd700] uppercase tracking-wider mb-4">GRAND FINALS</h3>
                        <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
                          <div className="flex gap-4 sm:gap-6 lg:gap-8 min-w-max pb-4">
                            {grandFinals.map((match) => {
                              const team1 = teams.find(t => t.id === match.team1_id);
                              const team2 = teams.find(t => t.id === match.team2_id);
                              
                              return (
                                <div 
                                  key={match.id} 
                                  className="bg-[#1a1a1a] border-2 border-[#ffd700] p-3 sm:p-4 hover:border-[#ffd700]/50 transition-all cursor-pointer min-w-[200px] sm:min-w-[220px] lg:min-w-[250px]"
                                  onClick={() => navigate(`/public/match/${match.id}`)}
                                >
                                  <div className="flex items-center justify-between mb-2">
                                    <span className="font-secondary text-[10px] sm:text-xs text-muted-foreground">GRAND FINALS</span>
                                    <span className="font-secondary text-[10px] sm:text-xs text-[#ffd700] uppercase">{match.status}</span>
                                  </div>
                                  <div className="space-y-1.5 sm:space-y-2">
                                    <div className={`flex items-center justify-between py-1.5 sm:py-2 px-2 sm:px-3 ${
                                      match.winner_id === match.team1_id ? 'bg-[#ffd700]/20' : 'bg-[#0a0a0a]'
                                    }`}>
                                      <div className="flex items-center gap-1.5 sm:gap-2 flex-1 min-w-0">
                                        {team1?.logo_url && (
                                          <img 
                                            src={team1.logo_url} 
                                            alt={team1.name} 
                                            className="w-5 h-5 sm:w-6 sm:h-6 object-contain flex-shrink-0"
                                            onError={(e) => { e.target.style.display = 'none'; }}
                                          />
                                        )}
                                        <span className="font-secondary text-xs sm:text-sm truncate">{team1?.name || 'TBD'}</span>
                                      </div>
                                      <span className="font-secondary text-xs sm:text-sm font-bold ml-2 flex-shrink-0">{match.team1_wins || 0}</span>
                                    </div>
                                    <div className={`flex items-center justify-between py-1.5 sm:py-2 px-2 sm:px-3 ${
                                      match.winner_id === match.team2_id ? 'bg-[#ffd700]/20' : 'bg-[#0a0a0a]'
                                    }`}>
                                      <div className="flex items-center gap-1.5 sm:gap-2 flex-1 min-w-0">
                                        {team2?.logo_url && (
                                          <img 
                                            src={team2.logo_url} 
                                            alt={team2.name} 
                                            className="w-5 h-5 sm:w-6 sm:h-6 object-contain flex-shrink-0"
                                            onError={(e) => { e.target.style.display = 'none'; }}
                                          />
                                        )}
                                        <span className="font-secondary text-xs sm:text-sm truncate">{team2?.name || 'TBD'}</span>
                                      </div>
                                      <span className="font-secondary text-xs sm:text-sm font-bold ml-2 flex-shrink-0">{match.team2_wins || 0}</span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
export function PublicMatchView() {
  const { id } = useParams();
  const [match, setMatch] = useState(null);
  const [teams, setTeams] = useState({});
  const [tournament, setTournament] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadMatch();
  }, [id]);

  const loadMatch = async () => {
    setLoading(true);
    try {
      // Get match details via public tournament matches
      const res = await axios.get(`${API}/public/matches/${id}`);
      const matchData = res.data;
      setMatch(matchData);

      if (matchData.team1_id) {
        const [teamsRes, tournamentRes] = await Promise.all([
          axios.get(`${API}/public/tournaments/${matchData.tournament_id}/teams`),
          axios.get(`${API}/public/tournaments/${matchData.tournament_id}`)
        ]);
        const teamsMap = {};
        teamsRes.data.forEach(t => teamsMap[t.id] = t);
        setTeams(teamsMap);
        setTournament(tournamentRes.data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner text="Chargement du match..." />;
  if (!match) return <div className="min-h-screen bg-[#050505] flex items-center justify-center font-secondary text-muted-foreground">Match non trouvé</div>;

  const team1 = teams[match.team1_id];
  const team2 = teams[match.team2_id];
  
  // Get bracket label
  const getBracketLabel = () => {
    if (match.bracket_type === "grand_finals") return "GRAND FINALS";
    if (match.bracket_type === "loser") return `LOSER BRACKET - ROUND ${match.bracket_round}`;
    
    // Winner bracket
    const totalRounds = tournament?.total_rounds || 0;
    if (match.bracket_round === totalRounds) return "FINALE";
    if (match.bracket_round === totalRounds - 1) return "DEMI-FINALE";
    if (match.bracket_round === totalRounds - 2) return "QUART DE FINALE";
    return `WINNER BRACKET - ROUND ${match.bracket_round}`;
  };

  return (
    <div className="min-h-screen bg-[#050505]">
      <div className="tactical-grid fixed inset-0 opacity-20" />
      
      <div className="relative z-10">
        <header className="border-b border-white/10 bg-black/50 backdrop-blur-sm">
          <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
            <button
              onClick={() => navigate(-1)}
              className="font-secondary text-xs text-[#ff4500] uppercase mb-3 sm:mb-4 hover:text-[#ff4500]/80"
            >
              ← RETOUR
            </button>
            <h1 className="font-primary font-black text-xl sm:text-2xl lg:text-3xl tracking-tighter uppercase">DÉTAILS DU MATCH</h1>
            {match && (
              <p className="font-secondary text-xs text-[#ff4500] mt-1 sm:mt-2 tracking-wider uppercase">
                {match.bracket_type === "grand_finals" ? "GRAND FINALS" : 
                 match.bracket_type === "loser" ? `LOSER BRACKET - ROUND ${match.bracket_round}` :
                 tournament && match.bracket_round === tournament.total_rounds ? "FINALE" :
                 tournament && match.bracket_round === tournament.total_rounds - 1 ? "DEMI-FINALE" :
                 tournament && match.bracket_round === tournament.total_rounds - 2 ? "QUART DE FINALE" :
                 `WINNER BRACKET - ROUND ${match.bracket_round}`}
              </p>
            )}
            <p className="font-secondary text-xs text-muted-foreground mt-1 sm:mt-2 tracking-wider">MODE VISITEUR - LECTURE SEULE</p>
          </div>
        </header>

        <main className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
          {match.status === 'completed' && (
            <div className="mb-6 sm:mb-8 text-center">
              <div className="bg-[#0a0a0a] border border-[#ff4500] p-4 sm:p-6 lg:p-8 inline-block">
                <h2 className="font-primary font-black text-xl sm:text-2xl uppercase text-[#ff4500] mb-2">VAINQUEUR</h2>
                <p className="font-secondary text-base sm:text-lg">{teams[match.winner_id]?.name}</p>
              </div>
            </div>
          )}

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 mb-6 sm:mb-8">
            <div className="bg-[#0a0a0a] border border-[#262626] p-4 sm:p-6 lg:p-8 corner-decoration relative">
              <h3 className="font-secondary text-xs text-muted-foreground uppercase tracking-wider mb-3 sm:mb-4">ÉQUIPE 1</h3>
              <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                {team1?.logo_url && (
                  <img 
                    src={team1.logo_url} 
                    alt={team1.name} 
                    className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 object-contain flex-shrink-0"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                )}
                <h2 className="font-primary font-black text-xl sm:text-2xl lg:text-3xl uppercase break-words">{team1?.name || 'TBD'}</h2>
              </div>
              {team1?.players?.length > 0 && (
                <ul className="flex flex-wrap gap-1.5 mb-3 sm:mb-4">
                  {team1.players.map((p, i) => (
                    <li key={i} className="font-secondary text-xs text-white/80 bg-white/5 px-2 py-1 rounded">{p}</li>
                  ))}
                </ul>
              )}
              <div className="font-secondary text-4xl sm:text-5xl font-black text-[#ff4500]">{match.team1_wins}</div>
              <p className="font-secondary text-xs text-muted-foreground mt-2">ROUNDS GAGNÉS</p>
            </div>

            <div className="bg-[#0a0a0a] border border-[#262626] p-4 sm:p-6 lg:p-8 corner-decoration relative">
              <h3 className="font-secondary text-xs text-muted-foreground uppercase tracking-wider mb-3 sm:mb-4">ÉQUIPE 2</h3>
              <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                {team2?.logo_url && (
                  <img 
                    src={team2.logo_url} 
                    alt={team2.name} 
                    className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 object-contain flex-shrink-0"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                )}
                <h2 className="font-primary font-black text-xl sm:text-2xl lg:text-3xl uppercase break-words">{team2?.name || 'TBD'}</h2>
              </div>
              {team2?.players?.length > 0 && (
                <ul className="flex flex-wrap gap-1.5 mb-3 sm:mb-4">
                  {team2.players.map((p, i) => (
                    <li key={i} className="font-secondary text-xs text-white/80 bg-white/5 px-2 py-1 rounded">{p}</li>
                  ))}
                </ul>
              )}
              <div className="font-secondary text-4xl sm:text-5xl font-black text-[#ff4500]">{match.team2_wins}</div>
              <p className="font-secondary text-xs text-muted-foreground mt-2">ROUNDS GAGNÉS</p>
            </div>
          </div>

          {match.rounds && match.rounds.length > 0 && (
            <>
              <div className="bg-[#0a0a0a] border border-[#262626] p-8 corner-decoration relative mb-8">
                <h2 className="font-primary font-black text-xl uppercase mb-6">PLANNING DES 5 ROUNDS - STYLE CDL</h2>
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                  {match.rounds.map((r, idx) => (
                    <div 
                      key={idx} 
                      className={`border relative overflow-hidden ${
                        r.completed ? 'border-[#00ff9d] bg-[#00ff9d]/5' : 'border-[#262626]'
                      }`}
                    >
                      <div className="relative">
                        <img 
                          src={r.map_image} 
                          alt={r.map_name} 
                          className="w-full h-32 object-cover opacity-80"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
                        <div className="absolute top-2 left-2 right-2 text-center">
                          <span className="font-secondary text-xs text-white/80 uppercase bg-black/60 px-2 py-1">Round {r.round_number}</span>
                        </div>
                        <div className="absolute bottom-0 left-0 right-0 p-3">
                          <p className="font-primary font-bold text-sm text-white uppercase text-center">{r.map_name}</p>
                          <p className="font-secondary text-xs text-[#00ff9d] uppercase text-center mt-1">{r.mode}</p>
                          {r.completed && (
                            <div className="text-center mt-2">
                              <span className="font-secondary text-xs bg-[#00ff9d]/20 text-[#00ff9d] px-2 py-1 border border-[#00ff9d]/50">✓ COMPLÉTÉ</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-[#0a0a0a] border border-[#262626] p-8 corner-decoration relative">
                <h3 className="font-secondary text-xs text-muted-foreground uppercase mb-4">HISTORIQUE DES ROUNDS</h3>
                <div className="space-y-2">
                  {match.rounds.filter(r => r.completed).map((r, idx) => {
                    const winnerTeam = r.winner ? teams[r.winner] : null;
                    const winnerName = winnerTeam ? winnerTeam.name : 'Égalité';
                    
                    return (
                      <div 
                        key={idx} 
                        className="py-3 px-4 bg-[#1a1a1a] border border-[#262626]"
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex-1">
                            <span className="font-secondary text-xs text-muted-foreground">Round {r.round_number}</span>
                            <p className="font-secondary text-sm font-bold text-[#00ff9d] mt-1">
                              {winnerName} a gagné
                            </p>
                          </div>
                          <div className="text-center mx-4">
                            <span className="font-secondary text-xs text-[#00ff9d]">{r.map_name}</span>
                            <p className="font-secondary text-xs text-muted-foreground">{r.mode}</p>
                          </div>
                          <div className="flex items-center gap-4">
                            <span className="font-secondary text-sm font-bold">{r.team1_score} - {r.team2_score}</span>
                          </div>
                        </div>
                        {r.score_image_url ? (
                          <div className="mt-3 pt-3 border-t border-white/10">
                            <p className="font-secondary text-[10px] text-muted-foreground uppercase mb-2">Photo du score</p>
                            <img
                              src={r.score_image_url}
                              alt={`Score round ${r.round_number}`}
                              className="w-full max-h-[520px] object-contain border border-white/10 bg-black/30"
                            />
                          </div>
                        ) : (
                          <p className="mt-3 pt-3 border-t border-white/10 font-secondary text-xs text-muted-foreground">
                            Aucune photo du score enregistrée.
                          </p>
                        )}
                      </div>
                    );
                  })}
                  {match.rounds.filter(r => r.completed).length === 0 && (
                    <p className="font-secondary text-xs text-muted-foreground text-center py-8">Aucun round complété</p>
                  )}
                </div>
              </div>
            </>
          )}

          {(!match.rounds || match.rounds.length === 0) && (
            <div className="bg-[#0a0a0a] border border-[#262626] p-8 corner-decoration relative text-center">
              <p className="font-secondary text-muted-foreground">Le match n&apos;a pas encore été démarré</p>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
